import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { HttpclientService } from "../../../../shared";
import { BatchNotifySelectRequest } from "./batch-notify-select-request";
import { BatchNotifyRequest } from "./batch-notify-request";

@Injectable()
export class DataService_PortalAppBatchNotify {
	constructor(private httpclientService: HttpclientService) {}

	loadGradeLevelList(applicationItemID, schoolID) {
		var postResult$ = new Subject();
		var url = "Report/GradeLevelRPTGetList?ApplicationItemID=" + applicationItemID + "&SchoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadHomeroomList(applicationItemID, schoolID) {
		var postResult$ = new Subject();
		var url = "Report/HomeRoomRPTGetList?ApplicationItemID=" + applicationItemID + "&SchoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadAcademyList(applicationItemID, schoolID) {
		var postResult$ = new Subject();
		var url = "Report/AcademyRPTGetList?ApplicationItemID=" + applicationItemID + "&SchoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadGroupList(applicationItemID, schoolID) {
		var postResult$ = new Subject();
		var url = "Report/GroupRPTGetList?ApplicationItemID=" + applicationItemID + "&SchoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BatchNotifySelectList(parms: BatchNotifySelectRequest) {
		var postResult$ = new Subject();
		var url = "PortalApps/BatchNotifySelectList?";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BatchNotify(parms: BatchNotifyRequest) {
		var postResult$ = new Subject();
		var url = "PortalApps/BatchNotify?";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
